import { createSlice } from "@reduxjs/toolkit";
import { AuditoriaContaFinanceiraVWModel } from "../../../models/auditoriaContaFinanceira/auditoriaContaFinanceiraVWModel";
import { BuscaAuditoriaContaFinanceiraModel } from "../../../models/auditoriaContaFinanceira/buscaAuditoriaContaFinanceiraModel";
import { AuditoriaContaFinanceiraModel } from "../../../models/auditoriaContaFinanceira/auditoriaContaFinanceiraModel";
import { buscarAuditoriaContaFinanceira, listarHistoricoAuditoriaContaFinanceira } from "../../../services/auditoriaContaFinanceiraService";
import { resetAll } from "../../actions/actions";
import dayjs from "dayjs";

dayjs.locale("pt-br");

export interface AuditoriaContaFinanceiraState {
  //buscar auditoria conta financeira
  loading: boolean;
  busca: BuscaAuditoriaContaFinanceiraModel;
  list: AuditoriaContaFinanceiraVWModel[];
  entity: AuditoriaContaFinanceiraVWModel;
  //buscar auditoria conta financeira historico
  loadingHistorico: boolean;
  listHistorico: AuditoriaContaFinanceiraModel[];
  //internal
  page: string;
  modalObservacao: boolean;
  modalHistorico: boolean;
  listSelecionada: AuditoriaContaFinanceiraVWModel[];
}

const initialState: AuditoriaContaFinanceiraState = {
  //buscar auditoria conta financeira
  loading: false,
  busca: {
    dataInicio: dayjs().startOf("month").toDate(),
    dataFim: dayjs().endOf("month").toDate(),
    idEmpresa: 0,
    tipoFiltroData: "VENCI",
    receitaDespesa: "D",
    filtros: null,
  } as BuscaAuditoriaContaFinanceiraModel,
  list: [],
  entity: {} as AuditoriaContaFinanceiraVWModel,
  //buscar auditoria conta financeira historico
  loadingHistorico: false,
  listHistorico: [],
  //internal
  page: "geral",
  modalObservacao: false,
  modalHistorico: false,
  listSelecionada: [],
};

export const auditoriaContaFinanceiraSlice = createSlice({
  name: "auditoriaContaFinanceira",
  initialState,
  reducers: {
    //buscar auditoria conta financeira
    setBuscaAuditoriaContaFinanceira: (state, action) => {
      state.busca = action.payload;
    },
    setEntityAuditoriaContaFinanceira: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setPageAuditoriaContaFinanceira: (state, action) => {
      state.page = action.payload;
    },
    setModalObservacaoAuditoriaContaFinanceira: (state, action) => {
      state.modalObservacao = action.payload;
    },
    setModalHistoricoAuditoriaContaFinanceira: (state, action) => {
      state.modalHistorico = action.payload;
    },
    setListaSelecionadaAuditoriaContaFinanceira: (state, action) => {
      state.listSelecionada = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar auditoria conta financeira
    builder.addCase(buscarAuditoriaContaFinanceira.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarAuditoriaContaFinanceira.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarAuditoriaContaFinanceira.rejected, (state, action) => {
      state.loading = false;
    });

    //buscar auditoria conta financeira historico
    builder.addCase(listarHistoricoAuditoriaContaFinanceira.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(listarHistoricoAuditoriaContaFinanceira.fulfilled, (state, action) => {
      state.listHistorico = action.payload;
      state.loading = false;
    });
    builder.addCase(listarHistoricoAuditoriaContaFinanceira.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar auditoria conta financeira
  setBuscaAuditoriaContaFinanceira,
  setEntityAuditoriaContaFinanceira,
  //internal
  setPageAuditoriaContaFinanceira,
  setModalObservacaoAuditoriaContaFinanceira,
  setModalHistoricoAuditoriaContaFinanceira,
  setListaSelecionadaAuditoriaContaFinanceira,
} = auditoriaContaFinanceiraSlice.actions;

export default auditoriaContaFinanceiraSlice.reducer;
